import { mediaConstants } from '../constants';
import { mediaService } from '../services';
import { showToast } from '../services/toast';

export const mediaActions = {
    fetchAllMedia,
    createMedia,
    updateMedia,
    deleteMedia
};

function fetchAllMedia() {
    return dispatch => {
        dispatch(request());

        mediaService.fetchAllMedia()
            .then(
                response => {
                    dispatch(success(response.data));
                },
                error => {
                    dispatch(failure(error));
                    if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
                }
            );
    };

    function request() { return { type: mediaConstants.FETCH_ALLMEDIA_REQUEST } }
    function success(medias) { return { type: mediaConstants.FETCH_ALLMEDIA_SUCCESS, medias } }
    function failure(error) { return { type: mediaConstants.FETCH_ALLMEDIA_FAILURE, error } }
}

function createMedia(formData) {
    return dispatch => {
        dispatch(request());

        return mediaService.createMedia(formData)
            .then(
                response => {
                    dispatch(success(response.data));
                    showToast(response.responseMessage, 'success');
                    return response;
                },
                error => {
                    dispatch(failure(error.toString()));
                    if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
                    return Promise.reject(error);
                }
            );
    };

    function request() { return { type: mediaConstants.CREATE_MEDIA_REQUEST } }
    function success(medias) { return { type: mediaConstants.CREATE_MEDIA_SUCCESS, medias } }
    function failure(error) { return { type: mediaConstants.CREATE_MEDIA_FAILURE, error } }
}

function updateMedia(formData) {
    return dispatch => {
        dispatch(request());

        return mediaService.updateMedia(formData)
            .then(
                response => {
                    dispatch(success(response.data));
                    showToast(response.responseMessage, 'success');
                    return response;
                },
                error => {
                    dispatch(failure(error.toString()));
                    if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
                    return Promise.reject(error);
                }
            );
    };

    function request() { return { type: mediaConstants.UPDATE_MEDIA_REQUEST } }
    function success(medias) { return { type: mediaConstants.UPDATE_MEDIA_SUCCESS, medias } }
    function failure(error) { return { type: mediaConstants.UPDATE_MEDIA_FAILURE, error } }
}

function deleteMedia(mediaId) {

    return dispatch => {
        dispatch(request());
        mediaService.deleteMedia(mediaId)
            .then(
                (res) => {
                    dispatch(success(mediaId));
                    showToast(res.responseMessage, 'success');
                },
                error => {
                    dispatch(failure(error.toString()));
                    if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
                }
            );
    };

    function request() { return { type: mediaConstants.DELETE_MEDIA_REQUEST } }
    function success(id) { return { type: mediaConstants.DELETE_MEDIA_SUCCESS, payload: id } }
    function failure(error) { return { type: mediaConstants.DELETE_MEDIA_FAILURE, error } }

}